import {EyeIcon, EyeOffIcon} from "lucide-react";
import {useState} from "react";

import {Button} from "@/components/ui/button";
import {Input} from "@/components/ui/input";

export function PasswordInput({...props}: React.InputHTMLAttributes<HTMLInputElement>) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="relative">
      <Input {...props} type={showPassword ? "text" : "password"} />
      <Button
        variant="ghost"
        size="icon"
        type="button"
        className="absolute right-2 top-1/2 -translate-y-1/2 hover:bg-transparent"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? <EyeIcon className="size-4" /> : <EyeOffIcon className="size-4" />}
      </Button>
    </div>
  );
}
